export default [
    {
        path: 'unidades',
        component: require('./unidades/Read').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminUnidadeController'
        }
    },
    {
        path: 'unidades/add',
        component: require('./unidades/Add').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminUnidadeController'
        }
    },
    {
        path: 'unidades/edit/:id',
        component: require('./unidades/Edit').default,
        meta: {
            middleware: 'auth',
            controller: 'AdminUnidadeController'
        }, children: [
            {
                path: 'cadastrar_tecnico',
                component: require('./unidades/includes/tecnicos/AddTecnico').default,
                meta: {
                    middleware: 'auth',
                    controller: 'TecnicoController'
                }
            },
        ]
    },
    {
        path: 'tiposunidade',
        component: require('./tiposdeunidades/Read').default,
        meta: {
            middleware: 'auth',
            controller: 'TipoUnidadeController'
        },
        children: [{
            path: 'add',
            component: require('./tiposdeunidades/Add').default,
            meta: {
                middleware: 'auth',
                controller: 'TipoUnidadeController'
            }
        },
        {
            path: 'edit/:id',
            component: require('./tiposdeunidades/Edit').default,
            meta: {
                middleware: 'auth',
                controller: 'TipoUnidadeController'
            }
        }
        ]
    },

    {
        path: 'relatorios/unidades',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/unidades/home',
        meta: { middleware: 'auth', controller: 'RelatorioUnidadeController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_unidades',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioUnidadeController' },
        }, {
            path: 'graficos',
            name: 'graficos_unidades',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioUnidadeController' },
        }
        ]
    }
]
